const PERMISSION_CONFIG = {
  USER_INDEX: 'user.index',
  USER_CREATE: 'user.create',
  USER_EDIT: 'user.edit',
  USER_DESTROY: 'user.destroy',
  ROLE_INDEX: 'role.index',
  ROLE_CREATE: 'role.create',
  ROLE_EDIT: 'role.edit',
  ROLE_DESTROY: 'role.destroy',
  CUSTOMER_INDEX: 'customer.index',
  ORDER_INDEX: 'order.index',
} as const

const PERMISSION_RESOURCES = [
  {
    key: 'user',
    name: 'Tài khoản',
    actions: [
      { code: 'user.index', name: 'Xem' },
      { code: 'user.create', name: 'Thêm' },
      { code: 'user.edit', name: 'Sửa' },
      { code: 'user.destroy', name: 'Xóa' }
    ]
  },
  {
    key: 'role',
    name: 'Vai trò',
    actions: [
      { code: 'role.index', name: 'Xem' },
      { code: 'role.create', name: 'Thêm' },
      { code: 'role.edit', name: 'Sửa' },
      { code: 'role.destroy', name: 'Xóa' }
    ]
  },
  {
    key: 'customer',
    name: 'Khách hàng',
    actions: [
      { code: 'customer.index', name: 'Xem' }
    ]
  },
  {
    key: 'order',
    name: 'Đơn hàng',
    actions: [
      { code: 'order.index', name: 'Xem' }
    ]
  }
]

export {
  PERMISSION_CONFIG,
  PERMISSION_RESOURCES
}
